import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import MediaMarquee from "@/components/MediaMarquee";

export default function Footer() {
  const { t, lang } = useLang();
  return (
    <footer
      className={`max-w-4xl mx-auto px-6 pb-10 pt-4 text-center text-[12px] text-[#6b6894] ${
        lang === "ta" ? "font-tamil" : ""
      }`}
      data-testid="site-footer"
    >
      <div className="mb-8 text-left"><MediaMarquee /></div>
      <div>
        {t("footer_prefix")}{" "}
        <a
          href="https://www.myneta.info/"
          target="_blank"
          rel="noreferrer"
          className="font-semibold underline decoration-2 underline-offset-2 hover:text-[#1a1640]"
          data-testid="footer-myneta-link"
        >
          MyNeta.info
        </a>
        {" "}{t("footer_and")}{" "}
        <a
          href="https://affidavit.eci.gov.in/"
          target="_blank"
          rel="noreferrer"
          className="font-semibold underline decoration-2 underline-offset-2 hover:text-[#1a1640]"
          data-testid="footer-eci-link"
        >
          {t("footer_eci")}
        </a>
        .
      </div>
      <div className="mt-2">
        <Link
          to="/contact"
          className="font-semibold underline decoration-2 underline-offset-2 hover:text-[#1a1640]"
          data-testid="footer-contact-link"
        >
          {t("contact_link")}
        </Link>
        <span className="mx-2 text-[#8c89ad]">·</span>
        <Link
          to="/about"
          className="font-semibold underline decoration-2 underline-offset-2 hover:text-[#1a1640]"
          data-testid="footer-about-link"
        >
          {t("about_link")}
        </Link>
        <span className="mx-2 text-[#8c89ad]">·</span>
        <Link
          to="/media"
          className="font-semibold underline decoration-2 underline-offset-2 hover:text-[#1a1640]"
          data-testid="footer-media-link"
        >
          {t("media_link")}
        </Link>
        <span className="mx-2 text-[#8c89ad]">·</span>
        <Link
          to="/changes"
          className="font-semibold underline decoration-2 underline-offset-2 hover:text-[#1a1640]"
          data-testid="footer-changes-link"
        >
          {t("nav_changes")}
        </Link>
        <span className="mx-2 text-[#8c89ad]">·</span>
        <Link
          to="/schemes"
          className="font-semibold underline decoration-2 underline-offset-2 hover:text-[#1a1640]"
          data-testid="footer-schemes-link"
        >
          {t("nav_schemes")}
        </Link>
      </div>

      <div
        className={`mt-10 sm:mt-12 text-left text-[8.5px] sm:text-[9px] leading-[1.5] text-[#a6a3c2] ${
          lang === "ta" ? "font-tamil" : ""
        }`}
        data-testid="footer-disclaimer"
      >
        <span className="font-semibold text-[#6b6894]">{t("disclaimer_title")}</span> {t("disclaimer_text")}
      </div>
    </footer>
  );
}
